import { FC, useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import { FormElement, MobileListItem } from '@mobileTypes'
import { useMobileListItems } from '@mobileHooks'
import { SingleListItemRenderer } from './SingleListItemRenderer'

interface ListItemElementPreviewProps {
  element: FormElement
  itemData?: any // Data to display (from variable or navigation params)
}

export const ListItemElementPreview: FC<ListItemElementPreviewProps> = ({
  element,
  itemData,
}) => {
  const { getListItemById } = useMobileListItems()

  // Get list item configuration
  const listItemConfig = useMemo(() => {
    if (element.listItemConfigId) {
      return getListItemById(element.listItemConfigId)
    }
    return null
  }, [element.listItemConfigId, getListItemById])

  // Mock data for preview if no itemData provided
  const displayData = useMemo(() => {
    if (itemData) {
      return itemData
    }
    // Return mock data for preview
    return {
      _id: 'preview_1',
      title: 'Sample Item',
      description: 'This is a preview of the list item',
      status: 'active',
    }
  }, [itemData])

  if (!listItemConfig) {
    return (
      <Box sx={{ p: 2, textAlign: 'center', border: '1px dashed', borderColor: 'divider', borderRadius: 1 }}>
        <Typography variant="body2" color="text.secondary">
          No list item configuration selected
        </Typography>
      </Box>
    )
  }

  // Create a complete MobileListItem for the preview
  const previewListItem: MobileListItem = {
    ...listItemConfig,
    id: listItemConfig.id || 'preview',
    name: listItemConfig.name || 'Preview',
    itemType: listItemConfig.itemType || 'dictionary',
    createdAt: listItemConfig.createdAt || Date.now(),
    updatedAt: listItemConfig.updatedAt || Date.now(),
  }

  return (
    <SingleListItemRenderer
      item={previewListItem}
      record={displayData}
      showChevron={false}
    />
  )
}
